import { useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import clienteAxios from '../../config/axios';
import { useT } from 'i18n';
import AuthContext from '../../context/autenticacion/authContext';
import ListaOferente from '../inversiones/ListaOferente';
import { fechaCorta, money, num } from './utils';
import './mercado.css';
import './mis.css';

const MisOfertas = () => {
  const { t, ts } = useT();
  const { mis_ofertas_inversor, mis_ofertas_oferente, TodosOfertas, TodosOferentes, TodosInversiones } = useContext(AuthContext);
  const [tab, setTab] = useState('ofertas');
  const [cargando, setCargando] = useState(true);
  const [cancelando, setCancelando] = useState(null);
  const [aviso, setAviso] = useState(null);
  const [apiload, setApiload] = useState(true);

  useEffect(() => {
    let vivo = true;
    Promise.all([TodosOfertas(), TodosOferentes()]).finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ofertas = useMemo(() => mis_ofertas_inversor || [], [mis_ofertas_inversor]);
  const proyectos = mis_ofertas_oferente || [];

  const total = useMemo(() => ofertas.reduce((a, o) => a + num(o.valorventa), 0), [ofertas]);

  const ApiLoad = () => { setApiload(false); setTimeout(() => setApiload(true), 3); };

  const cancelar = async (o) => {
    if (!window.confirm(t('ofertas.confirmarCancelar', { name: o.name }))) return;
    setCancelando(o.id);
    setAviso(null);
    try {
      const r = await clienteAxios.post(`/api/client/offers/cancel/${o.id}`);
      setAviso({ ok: true, texto: ts(r.data.message) || t('ofertas.canceladaDef') });
      await Promise.all([TodosOfertas(), TodosInversiones && TodosInversiones()]);
    } catch (e) {
      setAviso({ ok: false, texto: ts(e.response?.data?.message) || t('ofertas.errorCancelar') });
    } finally {
      setCancelando(null);
    }
  };

  return (
    <div className="content">
      <section className="p7x-hero">
        <h2>{t('ofertas.titulo')}</h2>
        <p>{t('ofertas.sub')}</p>
        <div className="p7x-kpis" style={{ gridTemplateColumns: 'repeat(2,minmax(0,1fr))', maxWidth: 520 }}>
          <div className="p7x-kpi"><span>{t('ofertas.kpiPublicadas')}</span><strong>{ofertas.length}</strong></div>
          <div className="p7x-kpi gold"><span>{t('ofertas.kpiValor')}</span><strong>${money(total)}</strong></div>
        </div>
      </section>

      {proyectos.length > 0 && (
        <div className="p7x-bar">
          <div className="p7-seg" role="tablist">
            <button type="button" className={tab === 'ofertas' ? 'on' : ''} onClick={() => setTab('ofertas')}>{t('ofertas.tabOfertas')}<span className="p7x-n">{ofertas.length}</span></button>
            <button type="button" className={tab === 'proyectos' ? 'on' : ''} onClick={() => setTab('proyectos')}>{t('ofertas.tabProyectos')}<span className="p7x-n">{proyectos.length}</span></button>
          </div>
        </div>
      )}

      {aviso && <div className={`p7x-aviso${aviso.ok ? '' : ' err'}`} role="status" onClick={() => setAviso(null)}>{aviso.texto}</div>}

      {tab === 'proyectos' ? (
        <ListaOferente apiload={apiload} ApiLoad={ApiLoad} />
      ) : cargando && ofertas.length === 0 ? (
        <div className="p7x-grid">{[0, 1, 2].map((i) => <div key={i} className="p7x-esq" />)}</div>
      ) : ofertas.length === 0 ? (
        <div className="p7x-vacio">
          <h3>{t('ofertas.vacio')}</h3>
          <p>{t('ofertas.vacioAyuda')}</p>
          <Link to="/cliente/inversiones" className="p7-btn-gold" style={{ textDecoration: 'none', display: 'inline-block' }}>{t('ofertas.irInversiones')}</Link>
        </div>
      ) : (
        <div className="p7x-grid">
          {ofertas.map((o) => (
            <article key={o.id} className="p7x-card">
              <div className="p7x-top">
                <div style={{ minWidth: 0 }}>
                  <h3>{o.name}</h3>
                  <span className="p7x-ref">{t('ofertas.ref', { id: o.id })}</span>
                </div>
                <span className="p7-chip p7-chip-wait">{t('ofertas.enVenta')}</span>
              </div>
              <div className="p7x-monto">
                <strong>${money(o.valorventa)}</strong>
                <span>{t('ofertas.precioVenta')}</span>
              </div>
              <dl className="p7x-datos">
                <div><dt>{t('ofertas.montoOfertado')}</dt><dd>${money(o.offers_amount)}</dd></div>
                <div><dt>{t('ofertas.rendimiento')}</dt><dd className="verde">+${money(o.rendimiento)}</dd></div>
                <div><dt>{t('ofertas.saldo')}</dt><dd>${money(o.saldo)}</dd></div>
                <div><dt>{t('ofertas.publicada')}</dt><dd>{fechaCorta(o.fecha_inicio)}</dd></div>
                <div><dt>{t('ofertas.vence')}</dt><dd>{fechaCorta(o.fecha_fin)}</dd></div>
              </dl>
              <div className="p7x-acc">
                <button type="button" className="p7-btn-ghost" disabled={cancelando === o.id} onClick={() => cancelar(o)}>
                  {cancelando === o.id ? t('ofertas.cancelando') : t('ofertas.cancelar')}
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default MisOfertas;
